<template>
    <div>
        <myPage :max_flag="true">
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                    <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="list()"></el-button>
                    <el-button size="small" @click="exportExcel" :title="$t('export')" icon="el-icon-download"></el-button>
                </el-button-group>
                <div class="f-bd f14 text-nowrap">账期{{$t('x_mh')}}</div>
                <div class="mg-right5 mg-top5"><myDatePicker v-model="search.datearea_id" @onChange="onDateChange"></myDatePicker></div>
                <div class="mg-top5"><el-button size="small" @click="list()">{{$t('list')}}</el-button></div>
            </div>
            <div class="fillw fillh">
                <el-table :data="listData" class="fillw show-scroll" height="100%">
                    <el-table-column fixed :label="listHeader.date_no">
                        <el-table-column label-class-name="f-red pd-top0" width="110px">
                            <div slot-scope="scope" slot="header">合计</div>
                            <div class="f-bd" slot-scope="scope">{{scope.row.date_no}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column fixed :label="listHeader.vendor_cname" prop="vendor_cname" width="180px"></el-table-column>
                    <el-table-column :label="listHeader.order_qty">
                        <el-table-column label-class-name="f-red pd-top0" width="120px">
                            <div slot-scope="scope" slot="header">{{totalData.sum.order_qty * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.order_qty * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.goods_amt">
                        <el-table-column label-class-name="f-red pd-top0" width="140px">
                            <div slot-scope="scope" slot="header">{{totalData.sum.goods_amt * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.goods_amt * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.cost_amt">
                        <el-table-column label-class-name="f-red pd-top0" width="140px">
                            <div slot-scope="scope" slot="header">{{totalData.sum.cost_amt * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.cost_amt * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column width="960px">
                        <template slot-scope="scope" slot="header">
                            <div class="flex-box nopadding">
                                <div class="tleft" style="width: 150px">{{listHeader2.goods_cname}}</div>
                                <div class="tleft" style="width: 100px">{{listHeader2.mac_goods_id}}</div>
                                <div class="tleft" style="width: 80px">{{listHeader2.order_qty}}</div>
                                <div class="tleft" style="width: 100px">{{listHeader2.goods_amt}}</div>
                                <div class="tleft" style="width: 100px">{{listHeader2.cost_amt}}</div>
                                <div class="tleft" style="width: 80px">{{listHeader2.fail_order_qty}}</div>
                                <div class="tleft" style="width: 100px">{{listHeader2.fail_goods_amt}}</div>
                                <div class="tleft" style="width: 120px">{{listHeader2.wait_order_qty}}</div>
                                <div class="tleft" style="width: 130px">{{listHeader2.wait_goods_amt}}</div>
                            </div>
                        </template>
                        <template slot-scope="scope">
                            <div class="flex-box nopadding border-bottom-line" v-for="(item2, index2) in scope.row.goods_info" :key="item2.vender_goods_id">
                                <div class="tleft" style="width: 150px">{{item2.goods_cname}}</div>
                                <div class="tleft" style="width: 100px">{{item2.mac_goods_id}}</div>
                                <div class="tleft f-red" style="width: 80px">{{item2.order_qty}}</div>
                                <div class="tleft f-red" style="width: 100px">{{item2.goods_amt * 1}}</div>
                                <div class="tleft f-red" style="width: 100px">{{item2.cost_amt * 1}}</div>
                                <div class="tleft" style="width: 80px">{{item2.fail_order_qty}}</div>
                                <div class="tleft" style="width: 100px">{{item2.fail_goods_amt * 1}}</div>
                                <div class="tleft" style="width: 120px">{{item2.wait_order_qty}}</div>
                                <div class="tleft" style="width: 130px">{{item2.wait_goods_amt * 1}}</div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column :label="listHeader.fail_order_qty">
                        <el-table-column label-class-name="f-red pd-top0" width="120px">
                            <div slot-scope="scope" slot="header">{{totalData.sum.fail_order_qty * 1}}</div>
                            <div class="f-bd" slot-scope="scope">{{scope.row.fail_order_qty * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.fail_goods_amt">
                        <el-table-column label-class-name="f-red pd-top0" width="140px">
                            <div slot-scope="scope" slot="header">{{totalData.sum.fail_goods_amt * 1}}</div>
                            <div class="f-bd" slot-scope="scope">{{scope.row.fail_goods_amt * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.wait_order_qty">
                        <el-table-column label-class-name="f-red pd-top0" width="130px">
                            <div slot-scope="scope" slot="header">{{totalData.sum.wait_order_qty * 1}}</div>
                            <div class="f-bd" slot-scope="scope">{{scope.row.wait_order_qty * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.wait_goods_amt">
                        <el-table-column label-class-name="f-red pd-top0" width="140px">
                            <div slot-scope="scope" slot="header">{{totalData.sum.wait_goods_amt * 1}}</div>
                            <div class="f-bd" slot-scope="scope">{{scope.row.wait_goods_amt * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.upd_time" prop="upd_time" width="150px"></el-table-column>
                </el-table>
            </div>
            <div slot="footer">
                <myPager slot="footer" :limit="search.limit" @onLimitChange="onLimitChange"
                         v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
            </div>
        </myPage>
    </div>
</template>

<script>
import myPager from '../../../components/myPager'
import myDatePicker from "../../../components/myDatePicker";
import excel from '../../../utils/excel'
export default {
    name:'report-vendorday',
    components:{
        myPager,
        myDatePicker
    },
    data: function(){
        const listHeader = {
            date_no: '账期',
            vendor_cname: '供应商',
            order_qty: '成功单量',
            goods_amt: '成功面值额',
            cost_amt: '成功结算价',
            cr_cat10_qty: '单量信誉消耗',
            cr_cat20_qty: '面额信誉消耗',
            fail_order_qty: '失败单量',
            fail_goods_amt: '失败面值额',
            wait_order_qty: '未完成单量(当日)',
            wait_goods_amt: '未完成面值额(当日)',
            upd_time: '结算时间'
        }
        const listHeader2 = {
            goods_cname: '商品名称',
            mac_goods_id: '供应商产品ID',
            order_qty: '成功单量',
            goods_amt: '成功面值额',
            cost_amt: '成功结算价',
            fail_order_qty: '失败单量',
            fail_goods_amt: '失败面值额',
            wait_order_qty: '未完成单量(当日)',
            wait_goods_amt: '未完成面值额(当日)',
        }
        return{
            relist: false,
            excel_frow_num: 2, //固定两行
            excel_fcol_num: 2, //固定三列
            data_key_name2: 'goods_info', //第二级数据名称
            search:{
                search_url: 'report-vendor-day/list',
                datearea_id:7,//如果大于0 mounted 要删除date_fr date_to
                date_fr: '',
                date_to: '',
                page: 1,
                pageSize: 0,
                limit:'30'
            },
            listHeader,
            listHeader2,
            listData:[],
            totalData: {
                total: 0,//总行数
                sum:{}
            },
            chart_data: {
                value_key:'mv_goods_amt',
                name_key:'date_no',
                line_value_key:'avg_goods_amt',
                rows: [],
            },
        }
    },
    activated:function(){
        this.$base.setMenuOpens();
    },
    mounted:function(){
        this.$base.setMenuOpens();
        this.$base.listPageInit(this,()=>{
            this.list();
        });
    },
    methods: {
        onDateChange: function(data){
            this.search.date_fr = data[0];
            this.search.date_to = data[1];
        },
        onPagerChange: function () {
            this.list(true);
        },
        onLimitChange: function (limit) {
            this.search.limit = limit;
            this.list();
        },
        list: function (change_page) {
            this.$base.list(this, change_page);
        },
        exportExcel: function(){
            // this.$base.exportExcelL3(this,'goods_info');
            excel.exportExcel(this);
        },
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/report/vendorday/list.vue